
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Plus } from 'lucide-react';
import { RepairLineItem } from '@/types/quick-compare';
import { ItemCard } from './ItemCard';

interface AddedItemsTabProps {
  addedItems: (RepairLineItem & { section?: string })[];
  count: number;
}

export const AddedItemsTab: React.FC<AddedItemsTabProps> = ({ addedItems, count }) => {
  return (
    <Card className="pt-4">
      <CardHeader>
        <CardTitle className="flex items-center">
          <Plus className="h-4 w-4 mr-2 text-green-600" /> 
          Added Items ({count})
        </CardTitle>
      </CardHeader>
      <CardContent>
        {addedItems.length > 0 ? (
          <div className="space-y-4">
            {addedItems.map((item, index) => (
              <ItemCard 
                key={index} 
                item={item} 
                variant="added"
              />
            ))}
          </div>
        ) : (
          <p className="text-muted-foreground">No items were added.</p>
        )}
      </CardContent>
    </Card>
  );
};
